export default "__VITE_ASSET__8f9344be__"